import { render, staticRenderFns } from "./AssignEmployee.vue?vue&type=template&id=4774dbbb"
import script from "./AssignEmployee.vue?vue&type=script&lang=ts"
export * from "./AssignEmployee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports